/**
 * Delete a Job (all versions).
 */

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import React, {useState} from 'react';
import {toast} from 'react-toastify';

import {useDeleteArtifactSequenceMutation} from '../../../generated/graphql';
import {Analytics} from '../../../services/analytics';
import {propagateErrorsContext} from '../../../util/errors';
import * as S from './DeleteJobDialog.styles';

interface DeleteJobDialogProps {
  jobId: string | null;
  jobName: string | null;
  onClose: () => void;
  onDelete?: () => void;
}

export const DeleteJobDialog: React.FC<DeleteJobDialogProps> = ({
  jobId,
  jobName,
  onClose,
  onDelete,
}) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const onClosing = () => {
    setIsDeleting(false);
    onClose();
  };

  const [deleteArtifactSequence] = useDeleteArtifactSequenceMutation({
    context: propagateErrorsContext(),
  });

  const onClickDelete = async () => {
    setIsDeleting(true);
    try {
      await deleteArtifactSequence({
        variables: {
          artifactSequenceID: jobId ?? '',
        },
      });
      if (onDelete) {
        onDelete();
      }
    } catch (err) {
      console.error(err);
      toast('Something went wrong while trying to delete this job.');
      Analytics.track('delete job error', {
        jobId,
        error: err,
        location: 'delete job dialog',
      });
    }
    setIsDeleting(false);
    onClose();
  };

  return (
    <Dialog
      onClose={onClosing}
      open={jobId != null}
      PaperProps={{style: {borderRadius: 10}}}>
      <div style={{margin: '36px 16px 24px 16px'}}>
        <DialogTitle>
          <S.ModalTitle>Delete this job?</S.ModalTitle>
        </DialogTitle>
        <DialogContent>
          <S.ModalContent>
            <b style={{fontWeight: 600}}>{jobName}</b> will be scheduled for
            deletion, including all versions and underlying files.
          </S.ModalContent>
        </DialogContent>
        <DialogActions>
          <Button
            disabled={isDeleting}
            onClick={onClickDelete}
            variant="destructive"
            size="large"
            className="ml-12">
            Delete job
          </Button>
          <Button onClick={onClosing} variant="ghost" size="large">
            Cancel
          </Button>
          <div style={{flexGrow: 1}} />
        </DialogActions>
      </div>
    </Dialog>
  );
};
